<script setup lang="ts">
import { useLangStore } from '@/stores/lang-store';
import { ja } from '@/locales/news/2026-01-28/lang-ja';
import { en } from '@/locales/news/2026-01-28/lang-en';
import { useAppStore } from '@/stores/app-store';
// -----------------------------------------------------
// [ store - lang ]
const langStore = useLangStore();
langStore.setMessage(en, ja);
const langConfig = ja;
const t = langStore.t;
const appStore = useAppStore();
// -----------------------------------------------------
// -----------------------------------------------------
definePageMeta({
  middleware: 'redirect',
  layout: 'default',
});
useHead({
  meta: [{ name: 'keywords', content: () => t('seo.keywords') }],
});
// プロパティ詳細は以下URL参照すること
// https://github.com/harlan-zw/zhead/blob/main/src/metaFlat.ts

const fixedGroupStype = computed(() => {
  return {
    'min-height': appStore.windowFixedH,
    'min-width': appStore.windowFixedW,
  };
});

// ---------------------------------------
</script>

<template>
  <div class="fixed-group bg-dark" :style="fixedGroupStype">
    <div class="fixed-innner">
      <div class="fixed-title">
        {{ t('title') }}
      </div>
      <div class="body">
        <div class="time">{{ t('dateLabel') }}</div>
        <div class="fixed-body">
          <div class="">{{ t('body') }}</div>
        </div>
        <div class="linkgroup">
          <div class="link">
            <NuxtLink :to="`/${langStore.state.lang}/`">Home</NuxtLink>
          </div>
          <div class="link">
            <NuxtLink :to="`/${langStore.state.lang}/contact-us`">{{ t('requestLink') }}</NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bg-dark {
  background-color: rgb(40, 40, 40);
  color: rgb(223, 223, 223);
}
.bg-light {
  background-color: rgb(238, 238, 238);
  color: rgb(24, 24, 24);
}

.fixed-group {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  @media screen and (min-width: #{ 0 }px) and (max-width: #{ 600 - 0.1}px) {
    padding: 50px 12px 50px 40px;
  }
  @media screen and (min-width: #{ 600 }px) {
    padding: 20px 0;
  }
}

.fixed-innner {
  background-color: rgba(43, 50, 104, 0.326);
  border: solid 1px gray;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: #{ 600 }px) {
    width: 70%;
    padding: 20px;
  }
}

.fixed-title {
  font-weight: 400;
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: rgb(40, 40, 40);
  padding: 2px 2px;
  @media screen and (min-width: #{ 600 }px) {
    font-size: 26px;
    text-align: center;
  }
}
.body {
  margin: 20px auto;
  font-size: 13px;
  max-width: 600px;
  @media screen and (min-width: #{ 600 }px) {
    font-size: 16px;
  }
  .time {
    color: rgb(224, 224, 224);
    padding: 4px auto;
    font-size: 11px;
    @media screen and (min-width: #{ 600 }px) {
      font-size: 14px;
    }
  }
}

.fixed-body {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.7em;

  @media screen and (min-width: #{ 600 }px) {
    font-size: 16px;
  }
  > div {
    margin: 0 auto;
  }
}

.linkgroup {
  margin-top: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.link a {
  border-top: solid 1px white;
  border-bottom: solid 1px white;
  color: white;
  text-decoration: none;
  padding: 4px 8px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.404);
  }
  &:active {
    background-color: rgba(255, 255, 255, 0.155);
  }
}
</style>
